function AddTimelineModal({
  isOpen,
  timelineDate,
  setTimelineDate,
  timelineMod,
  setTimelineMod,
  editingTimelineId,
  onSave,
  onCancel
}) {
  if (!isOpen) return null;

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <h2 style={{ marginTop: 0 }}>
          {editingTimelineId ? "Edit Timeline Entry" : "Add Timeline Entry"}
        </h2>

        <label style={labelStyle}>Event Date</label>
        <input
          type="date"
          value={timelineDate}
          onChange={(e) => setTimelineDate(e.target.value)}
          style={inputStyle}
        />

        <textarea
          placeholder="Example: First track day, dyno session, wrap installed, engine rebuild..."
          value={timelineMod}
          onChange={(e) => setTimelineMod(e.target.value)}
          style={{ ...inputStyle, height: "110px" }}
        />

        <div style={buttonRowStyle}>
          <button onClick={onCancel} style={cancelButtonStyle}>
            Cancel
          </button>

          <button onClick={onSave} style={saveButtonStyle}>
            {editingTimelineId ? "Save Changes" : "Add Entry"}
          </button>
        </div>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0,0,0,0.82)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 30000,
  padding: "20px"
};

const modalStyle = {
  backgroundColor: "#181818",
  border: "1px solid #333",
  borderRadius: "20px",
  padding: "22px",
  maxWidth: "420px",
  width: "100%",
  boxSizing: "border-box",
  color: "white",
  display: "flex",
  flexDirection: "column",
  gap: "12px"
};

const inputStyle = {
  padding: "14px",
  borderRadius: "12px",
  border: "1px solid #2a2a2a",
  backgroundColor: "#1c1c1c",
  color: "white",
  boxSizing: "border-box",
  width: "100%",
  fontSize: "16px"
};

const buttonRowStyle = {
  display: "flex",
  gap: "10px",
  marginTop: "10px"
};

const cancelButtonStyle = {
  flex: 1,
  backgroundColor: "#333",
  color: "white",
  border: "none",
  borderRadius: "12px",
  padding: "14px",
  fontWeight: "bold",
  cursor: "pointer"
};

const saveButtonStyle = {
  flex: 1,
  backgroundColor: "#e10600",
  color: "white",
  border: "none",
  borderRadius: "12px",
  padding: "14px",
  fontWeight: "bold",
  cursor: "pointer"
};

const labelStyle = {
  display: "block",
  marginBottom: "6px",
  marginTop: "12px",
  fontSize: "12px",
  fontWeight: "600",
  color: "#fff"
};

export default AddTimelineModal;